export const type = {
    'warning': 'warning',
    'error': 'error',
    'success': 'green',
    'reminder': 'accent',
}
